import { AdminCard } from './components/AdminCard';

import { ADMIN_CARDS } from '@/config/adminCards';
import { useFavoriteAdminCards } from '@/store/favoriteAdminCardsStore';

export function AdminDashboard() {
  const favorites = useFavoriteAdminCards((state) => state.favorites);
  const toggleFavorite = useFavoriteAdminCards((state) => state.toggleFavorite);

  return (
    <div style={{ minHeight: '100vh' }}>
      <h1 className="mb-2 text-4xl font-bold">Admin Dashboard</h1>
      <p className="mb-8 text-gray-600">
        Star a card to pin it to the top menu.
      </p>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {ADMIN_CARDS.map((card) => (
          <AdminCard
            key={card.id}
            card={card}
            isFavorite={favorites.includes(card.id)}
            onToggleFavorite={toggleFavorite}
          />
        ))}
      </div>
    </div>
  );
}
